import React, { Component } from 'react';
import { Icon, Input, AutoComplete, Button, Table, Popconfirm, message, Select, Tabs, Tag, Card } from 'antd';
import { Redirect } from 'react-router';
import utils from '../../../utils/common';
import './list.css';
import TreeMenu from '../../../components/backEnd/treeMenu';

const { Option } = AutoComplete;
const { Option: SelectOption } = Select;
const { TabPane } = Tabs;
class ProductList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: 0,
      productNameData: [], ///商品名称数据
      menuData: ['出售中的商品', '已下架的商品'],
      statusTxt: '下架',
      statusCon: '是否确定要下架此产品？',
      pagination: {
        page_size: 10,
        current: 1,
        total: null,
        onChange: this.changePage
      },
      status: 0,
      goodsList: [],
      redirect: false,
      isLoading: true,
      treeData: [], // 分类列表
      brandList: [], // 品牌列表
      allowClear: true, // 支持品牌框清除内容
      goods_name: '',
      goods_bar_no: '',
      goods_brand_id: undefined, // 品牌id
      goods_category_id: ''
    };
  }

  //数据加载，dom未初始化
  componentWillMount() {
    if (window.common.loginOut(this)) {
      Promise.all([window.api('eps.getgoodsbrand', {page_size: 100}), window.api('goods.getcategorylist', {})]).then((res) => {
        this.loadList(1, this.state.status);
        this.setState({brandList: res[0].goods_brand_list, treeData: res[1].goods_category_list});
      });
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 渲染
  renderOption(item) {
    return (
      <Option key={item.name} text={item.name}>
        {item.name}
      </Option>
    );
  }

  // 获取商品列表
  loadList = (currentPage, status) => {
    let params = {
      page_size: 10,
      current_page: currentPage,
      status,
      goods_category_id: this.state.goods_category_id,
      goods_bar_no: this.state.goods_bar_no,
      goods_name: this.state.goods_name,
      goods_brand_id: this.state.goods_brand_id,
      is_source_cms: window.localStorage.getItem('sourceCMS') === '1' ? 1 : '',
    };
    params = utils.dealElement(params);
    window.api('goods.getgoodslist', params).then(rs => {
      const pagination = {
        page_size: 10,
        current: Number(currentPage),
        total: Number(rs.total_result),
        onChange: this.changePage
      };
      this.setState({goodsList: rs.goods_list, isLoading: false, pagination});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
      this.setState({isLoading: false});
    });
  }

  // 根据tab切换提示框显示内容
  async selTap(index) {
    const statusTxt = index !== 0 ? '出售' : '下架';
    const statusCon = index !== 0 ? '是否确定要出售此产品？' : '是否确定要下架此产品？';
    await this.setState({
      isActive: index,
      statusTxt,
      statusCon,
      status: index,
      goods_name: '',
      goods_bar_no: '',
      goods_brand_id: undefined,
      goods_category_id: '',
    });
    this.loadList(1, index);
  }

  // 是否下架或重新出售
  confirm = (item) => {
    const success = false;
    const status = item.status === 0 ? 1 : 0;
    const params = {id: item.id, status,success};
    window.api('goods.modgoods', params).then(rs => {
      message.success(rs.service_error_message);
      this.loadList(this.state.pagination.current, this.state.status);
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 获取搜索信息
  getSearchInfo(type, value) {
    if (value === undefined) return;
    value = utils.deleteBlank(value);
    if (type === 'goods_bar_no') {
      this.setState({[type]: value.target.value});
      return;
    }
    this.setState({[type]: value});
  }

  // 按条件获取列表
  changePage = (page) => {
    page = page === 0 ? 1 : page;
    this.loadList(page, this.state.status);
  }

  // 跳转到添加/编辑商品页面
  addProduct = (id) => {
    this.props.history.push('/main/addGoods', {id});
  }
  render() {
    const {
      brandList, statusCon, statusTxt, redirect, menuData, isActive, productNameData, goodsList, pagination, isLoading, allowClear
    } = this.state;
    const columns = [
      {
        title: '商品',
        key: 'goods_name',
        width: 280,
        render: (_, record) => (
          <div className="product-list-cell product-cell">
            <img src={record.goods_picture} alt="" className="product-cell__img" />
            <span className="product-cell__name">{record.goods_name}</span>
          </div>
        )
      },
      {
        title: '商品类型',
        key: 'goods_category_name',
        dataIndex: 'goods_category_name',
        width: 120,
        ellipsis: true
      },
      {
        title: '单价',
        key: 'sale_price',
        dataIndex: 'sale_price',
        width: 100,
        render: (val) => val != null ? `¥ ${Number(val).toFixed(2)}` : '—'
      },
      {
        title: '条形码',
        key: 'goods_bar_no',
        dataIndex: 'goods_bar_no',
        width: 140,
        ellipsis: true
      },
      {
        title: '库存',
        key: 'goods_num',
        dataIndex: 'goods_num',
        width: 80,
      },
      {
        title: '状态',
        key: 'status',
        dataIndex: 'status',
        width: 90,
        render: (status) => (
          <Tag color={status === 1 ? 'orange' : 'green'}>{status === 1 ? '已下架' : '出售中'}</Tag>
        )
      },
      {
        title: '已售',
        key: 'sell_out',
        dataIndex: 'sell_out',
        width: 80,
      },
      {
        title: '操作',
        key: 'operation',
        width: 160,
        render: (_, record) => (
          <div className="product-list-actions">
            <Button type="link" size="small" onClick={() => this.addProduct(record.id)}>编辑</Button>
            <Popconfirm
              title={statusCon}
              onConfirm={() => this.confirm(record)}
              okText="确定"
              cancelText="取消"
            >
              <Button type="link" size="small">{statusTxt}</Button>
            </Popconfirm>
          </div>
        )
      }
    ];
    if (redirect) return <Redirect to="/login" />;

    return (
      <div className="product-list-page">
        <div className="product-list-header">
          <Tabs activeKey={String(isActive)} onChange={(key) => this.selTap(Number(key))} type="card" className="product-list-tabs">
            {menuData.map((item, index) => (
              <TabPane tab={item} key={String(index)} />
            ))}
          </Tabs>
          <Button type="primary" icon="plus" onClick={() => this.addProduct(0)} className="product-list-add-btn">
            新增商品
          </Button>
        </div>

        <Card className="product-list-filter" bordered={false}>
          <div className="product-list-filter__row">
            <div className="product-list-filter__item">
              <span className="product-list-filter__label">商品名称</span>
              <AutoComplete
                className="product-list-filter__input"
                dropdownMatchSelectWidth={false}
                dataSource={productNameData.map(this.renderOption)}
                onBlur={(e) => e.target && this.getSearchInfo('goods_name', e.target.value)}
                placeholder="请输入商品名称"
                optionLabelProp="text"
                onSelect={this.getSearchInfo.bind(this, 'goods_name')}
                onChange={this.getSearchInfo.bind(this, 'goods_name')}
                value={this.state.goods_name}
                style={{ width: '100%' }}
              >
                <Input suffix={<Icon type="search" />} allowClear />
              </AutoComplete>
            </div>
            <div className="product-list-filter__item">
              <span className="product-list-filter__label">条形码</span>
              <Input
                className="product-list-filter__input"
                value={this.state.goods_bar_no}
                onChange={this.getSearchInfo.bind(this, 'goods_bar_no')}
                placeholder="请输入条形码"
                allowClear
                style={{ width: '100%' }}
              />
            </div>
            <div className="product-list-filter__item">
              <span className="product-list-filter__label">商品类型</span>
              <TreeMenu className="product-list-filter__input" selParentEvent={(value) => this.getSearchInfo('goods_category_id', value)} parent_id={this.state.goods_category_id} treeData={this.state.treeData} />
            </div>
            <div className="product-list-filter__item">
              <span className="product-list-filter__label">商品品牌</span>
              <Select
                className="product-list-filter__input product-list-filter__select"
                value={this.state.goods_brand_id}
                placeholder="请选择品牌"
                onChange={this.getSearchInfo.bind(this, 'goods_brand_id')}
                allowClear={allowClear}
                style={{ width: '100%' }}
              >
                {brandList.map((item, index) => (
                  <SelectOption value={item.id} key={item.id}>{item.brand_name}</SelectOption>
                ))}
              </Select>
            </div>
            <div className="product-list-filter__actions">
              <Button type="primary" icon="search" onClick={() => this.loadList(1, this.state.status)}>查询</Button>
              <Button onClick={() => this.setState({ goods_name: '', goods_bar_no: '', goods_brand_id: undefined, goods_category_id: '' }, () => this.loadList(1, this.state.status))}>重置</Button>
            </div>
          </div>
        </Card>

        <Card className="product-list-table-card" bordered={false}>
          <Table
            columns={columns}
            dataSource={goodsList}
            pagination={{ ...pagination, showSizeChanger: true, showTotal: (total) => `共 ${total} 条` }}
            className="product-list-table"
            rowKey={(record) => record.id}
            loading={isLoading}
            scroll={{ x: 1000 }}
          />
        </Card>
      </div>
    );
  }
}
export default ProductList;




// WEBPACK FOOTER //
// ./src/containers/backEnd/productManagement/list.jsx